import Siema from 'siema';

export default {
    name: 'siema',
    _container: null,
    _galleries: [],
    init() {
        this._containers = document.querySelectorAll('[data-siema]');
        if (!this._containers) {
            return;
        }

        for (const container of this._containers) {
            const siema = new Siema({
                selector: container,
                loop: true,
                onChange: function() {
                    const indexContainer = this.selector.parentElement.querySelector('[data-index]');
                    if (indexContainer) {
                        indexContainer.innerHTML = this.currentSlide + 1 + '/' + this.innerElements.length;
                    }
                }
            });
            this._galleries.push({
                siema   : siema,
                prev    : container.parentElement.querySelector('[data-prev]'),
                next    : container.parentElement.querySelector('[data-next]'),
            });
        }

        for (const gallery of this._galleries) {
            gallery.prev.addEventListener('click', () => {
                gallery.siema.prev();
            });
            gallery.next.addEventListener('click', () => {
                gallery.siema.next();
            });
        }
    }
}